module.exports = __webpack_public_path__ + "static/media/toggle-on.42480d65.svg";